const state = {
    layoutClasses: ''
}

const getters = {
    layoutClasses(state) {
        return state.layoutClasses
    }
}

const mutations = {
    setLayoutClasses(state, classes) {
        state.layoutClasses = classes
    }
}

const actions = {
    setLayoutClasses({ dispatch, commit }, classes) {
        dispatch('siteLoader/open', 'master', { root: true })

        setTimeout(() => {
            commit('setLayoutClasses', classes)
            document.documentElement.classList.add(classes)
            
            dispatch('siteLoader/close', {}, { root: true })
        }, 300)
    },

    clearLayoutClasses({ dispatch, commit }) {
        dispatch('siteLoader/open', 'master', { root: true })

        setTimeout(() => {
            commit('setLayoutClasses', '')
            document.documentElement.className = ''
            
            dispatch('siteLoader/close', {}, { root: true })
        }, 300)
    }
}

export default {
    state,
    getters,
    mutations,
    actions,
    namespaced: true
}